export const emailInputRegex = /^[a-z0-9_%&'+/.=-]+@(?!.*\.\.)([a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]+$/i